import appConfiguration from "@/components/cfg/AppCfg";
import { normalizeS3Key } from "@/lib/utils";

/**
 * Builds a download URL for a file using its key.
 */
export const buildFileUrl = (s3Key?: string): string | null => {
  if (!s3Key) return null;
  const normalizedKey = normalizeS3Key(s3Key);
  return `${appConfiguration.baseUrl}/${normalizedKey}`;
};
